// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__5dNy-","Label":"BuildControl_Label__2XZNk","Less":"BuildControl_Less__nFpSF","More":"BuildControl_More__2FrYR"};